import { usePWAContext } from "./PWAProvider";
import { MdSystemUpdate } from "react-icons/md";

const UpdatePrompt = () => {
  const { updateAvailable, applyUpdate } = usePWAContext();

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-blue-600 text-white px-5 py-3 rounded-xl shadow-xl flex items-center gap-3">
      <MdSystemUpdate size={20} />
      <p className="text-sm font-medium">New version available</p>
      <button
        onClick={applyUpdate}
        className="bg-white text-blue-600 px-3 py-1 rounded-lg text-xs font-semibold hover:bg-blue-50"
      >
        Update Now
      </button>
    </div>
  );
};

export default UpdatePrompt;